import { useRef, useState } from "react";
import { toPng } from "html-to-image";
import tlcLogo from "@assets/TLC_Logo_1776354004749.webp";
import heroBg from "@assets/Homepage_Hero_TLC_Associates_Desktop_1775950961981.webp";

export default function GBPCover() {
  const coverRef = useRef<HTMLDivElement>(null);
  const [exporting, setExporting] = useState(false);

  const handleDownload = async () => {
    if (!coverRef.current) return;
    setExporting(true);
    try {
      const dataUrl = await toPng(coverRef.current, {
        width: 1024,
        height: 576,
        pixelRatio: 1,
        cacheBust: true,
      });
      const link = document.createElement("a");
      link.download = "tlc-associates-gbp-cover.png";
      link.href = dataUrl;
      link.click();
    } catch (err) {
      console.error("Export failed:", err);
    } finally {
      setExporting(false);
    }
  };

  return (
    <>
      <title>Google Business Profile Cover Generator | TLC Associates</title>
      <meta name="robots" content="noindex" />
      <div
        style={{
          minHeight: "100vh",
          backgroundColor: "#111",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "48px 24px",
          fontFamily: "'DM Sans', sans-serif",
        }}
      >
        <p style={{ color: "rgba(255,255,255,0.5)", fontSize: 13, marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.1em" }}>
          Google Business Profile Cover Generator
        </p>
        <h1 style={{ color: "#ffffff", fontSize: 22, fontWeight: 600, marginBottom: 32 }}>
          TLC Associates — 1024 × 576
        </h1>

      {/* ── Cover frame (captured by html-to-image) ── */}
        <div
        ref={coverRef}
        style={{
          width: 1024,
          height: 576,
          position: "relative",
          overflow: "hidden",
          flexShrink: 0,
        }}
      >
        {/* Background photo */}
        <img
          src={heroBg}
          alt=""
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center 40%",
          }}
          crossOrigin="anonymous"
        />

        {/* Dark green overlay */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "#1a3a1a",
            opacity: 0.62,
          }}
        />

        {/* Safe-zone content */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "52px 96px",
          }}
        >
          {/* Logo */}
          <img
            src={tlcLogo}
            alt="TLC Associates"
            style={{ height: 88, width: "auto", marginBottom: 20 }}
            crossOrigin="anonymous"
          />

          {/* Yellow rule */}
          <div style={{ width: 56, height: 3, backgroundColor: "#f5c828", borderRadius: 2, marginBottom: 20 }} />

          {/* Company name */}
          <div
            style={{
              fontFamily: "'Fraunces', serif",
              fontWeight: 900,
              fontSize: 58,
              color: "#ffffff",
              lineHeight: 1.05,
              textAlign: "center",
              marginBottom: 14,
              letterSpacing: "-0.5px",
            }}
          >
            TLC Associates
          </div>

          {/* Tagline */}
          <div
            style={{
              fontFamily: "'DM Sans', sans-serif",
              fontWeight: 500,
              fontSize: 18,
              color: "rgba(255,255,255,0.82)",
              textAlign: "center",
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              marginBottom: 30,
            }}
          >
            Professional Landscaping &amp; Property Maintenance
          </div>

          {/* Contact row */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 20,
              fontFamily: "'DM Sans', sans-serif",
              fontWeight: 500,
              fontSize: 14,
              color: "rgba(255,255,255,0.65)",
              letterSpacing: "0.04em",
            }}
          >
            <span>tlcassociates.llc</span>
            <span style={{ color: "#f5c828", fontSize: 5 }}>●</span>
            <span>Franklin, MA</span>
            <span style={{ color: "#f5c828", fontSize: 5 }}>●</span>
            <span>508-505-1539</span>
          </div>
        </div>

        {/* Bottom accent stripe */}
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: 5,
            backgroundColor: "#c84060",
          }}
        />
        </div>

      {/* Controls */}
        <button
        onClick={handleDownload}
        disabled={exporting}
        style={{
          marginTop: 32,
          backgroundColor: exporting ? "#666" : "#c84060",
          color: "#fff",
          border: "none",
          padding: "14px 36px",
          borderRadius: 8,
          fontSize: 16,
          fontWeight: 600,
          cursor: exporting ? "not-allowed" : "pointer",
          fontFamily: "'DM Sans', sans-serif",
          transition: "background-color 0.2s",
        }}
      >
        {exporting ? "Exporting…" : "Download PNG (1024×576)"}
        </button>

        <p style={{ color: "rgba(255,255,255,0.35)", fontSize: 13, marginTop: 12, fontFamily: "'DM Sans', sans-serif" }}>
          Ready to upload to Google Business Profile
        </p>
      </div>
    </>
  );
}
